import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getSubjectId } from '../../pages/biomarkers/[id]/IndicatorsAndSignals'

export const Redirecting = () => {
    const navigate = useNavigate()
    useEffect(() => {
        navigate('/create-theme', { replace: true })
    }, [navigate])
    return null
}

export const RedirectToBiomarkers = () => {
    const navigate = useNavigate()
    useEffect(() => {
        navigate('/' + getSubjectId() + '/biomarkers')
    }, [navigate])
    return null
} 